"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EditorConfigProvider = EditorConfigProvider;
exports["default"] = void 0;
exports.useEditorConfig = useEditorConfig;

var _react = _interopRequireDefault(require("react"));

var _excluded = ["config"];

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var EditorConfigContext = /*#__PURE__*/_react["default"].createContext();

function EditorConfigProvider(_ref) {
  var config = _ref.config,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement(EditorConfigContext.Provider, _extends({
    value: config
  }, props));
}

function useEditorConfig() {
  var context = _react["default"].useContext(EditorConfigContext);

  if (context === undefined) {
    throw new Error('useConfig must be used with EditorConfigProvider');
  }

  return context;
}

var _default = EditorConfigContext;
exports["default"] = _default;